<template>
  <div class="portfolio-box">
    <h2>Customer Information</h2>

    <div v-if="customer.profilePictureUrl" class="profile-picture">
      <img :src="customer.profilePictureUrl" alt="Profile Picture" />
    </div>

    <p><strong>Name:</strong> {{ customer.name }}</p>
    <p><strong>Clinic:</strong> {{ customer.clinic }}</p>
    <p><strong>Email:</strong> {{ customer.email }}</p>
    <p><strong>User ID:</strong> {{ customer.userId }}</p>
    <p><strong>Created At:</strong> {{ formatDate(customer.createdAt) }}</p>
    <p><strong>Updated At:</strong> {{ formatDate(customer.updatedAt) }}</p>
    <p><strong>Email Verified:</strong> {{ customer.emailVerified ? 'Yes' : 'No' }}</p>
    <p><strong>Status:</strong> {{ customer.status }}</p>
    <p><strong>Role:</strong> {{ customer.role }}</p>

    <div class="button-row">
      <button @click="$emit('reset-password', customer.email)">
        Reset Password
      </button>
      <button @click="$emit('resend-activation', customer.email)">
        Resend Activation
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['customer'],
  methods: {
    formatDate(date) {
      if (!date) return 'N/A';
      const d = new Date(date);
      return d.toLocaleString();
    }
  }
};
</script>

<style scoped>
.portfolio-box {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 800px;
  text-align: center;
}

.profile-picture img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 10px;
}

/* Button layout */
.button-row {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 20px;
}

/* Buttons */
button {
  padding: 10px 18px;
  border: none;
  border-radius: 25px;
  background-color: #4e45cc;
  color: white;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(78, 69, 204, 0.2);
  transition: background-color 0.3s, transform 0.2s;
}

button:hover {
  background-color: #3c36a8;
  transform: translateY(-1px);
}
</style>
